import { Moment } from "moment";

import flight_pb from "@skydio/pbtypes/pbtypes/tools/cloud_api/flight_pb";

import { Overwrite } from "@skydio/common_util/src";
import { PaginationQueryState, StringifyPagination } from "../pagination/types";
import type { ValueType } from "@skydio/core";

export type APIFlight = flight_pb.Flight.AsObject;

export interface Flight extends Omit<APIFlight, "takeoff" | "dataFilesList"> {
  takeoff: Moment | null;
  landing: Moment | null;
  dataFiles: string[];
}

export interface FlightsMap {
  [flightId: string]: Flight;
}

export type AggregateFlights = Omit<flight_pb.AggregateFlights.AsObject, "id">;
export interface AggregateFlightsMap {
  [id: string]: AggregateFlights;
}

export const FlightStatsIdType = flight_pb.FlightStats.IdTypeEnum;
export type FlightStatsIdType = ValueType<flight_pb.FlightStats.IdTypeEnumMap>;
export type FlightStatsIdTypeKey = keyof typeof FlightStatsIdType;
export type FlightStatsDuration = "day" | "week" | "month" | "year";
export type FlightOrderBy = "duration" | "takeoff";

export type FlightStatsState = Partial<Record<FlightStatsIdTypeKey, AggregateFlightsMap>>;

export interface FlightsQueryState extends PaginationQueryState {
  vehicleId: string[];
  userEmail: string;
  takeoffUserId: string[];
  takeoffPhoneId: string;
  deployCommit: string;
  takeoffSince?: Moment;
  takeoffBefore?: Moment;
  releaseKey: string;
  handle: string;
  organizationId: string;
  userGroup: string[];
  userNotGroup: string[];
  dockId?: string[];
  batterySerial?: string[];
  sensorPackageSerial?: string[];
  attachmentSerial?: string[];
  resourceGroupIds?: string[];
  limit?: number;
  hasDataFiles?: boolean;
  orderAscending?: boolean;
  orderBy?: FlightOrderBy;
  includeInvalidFlights?: boolean;
  timezone?: string;
}

export interface FlightsRequest
  extends Overwrite<
    Partial<FlightsQueryState>,
    {
      takeoffSince?: string;
      takeoffBefore?: string;
      hasDataFiles?: string;
      orderAscending?: string;
      includeInvalidFlights?: "1" | "0";
      timezone?: string;
    }
  > {}

export interface FlightStatsRequest extends FlightsRequest {
  aggregateType: FlightStatsIdType;
}

export type FlightsQueryParams = Overwrite<
  StringifyPagination<FlightsRequest>,
  {
    userGroup?: string | string[];
    userNotGroup?: string | string[];
    vehicleId?: string | string[];
    takeoffUserId?: string | string[];
    dockId?: string | string[];
    batterySerial?: string | string[];
    sensorPackageSerial?: string | string[];
    attachmentSerial?: string | string[];
    resourceGroupIds?: string | string[];
    limit?: string;
  }
>;

export interface FlightRequest {
  path: { flightId: string };
}
